/* eslint-disable no-param-reassign */

import _ from 'underscore';

import otherItemTemplate from './other-section-template.pug';
import { TextWithCustomValidatorView } from './custom-text-view';

export class OtherSectionFactory {
  constructor({ i18n }) {
    this.i18n = i18n;
  }

  generateOtherItemTemplateForForm(description) {
    return options => (
      otherItemTemplate(_.extend({
        description,
      }, options))
    );
  }

  generateFindViewForForm() {
    const headerText = this.i18n.getString('Import_ImportOptions_FindWhat');

    return class FindView extends TextWithCustomValidatorView {
      initialize({ observable, field }) {
        field.ariaLabel = headerText;

        super.initialize({
          observable,
          field,
          headerText,
        });
      }
    };
  }

  generateReplaceViewForForm() {
    const headerText = this.i18n.getString('Import_ImportOptions_ReplaceWith');

    return class ReplaceView extends TextWithCustomValidatorView {
      initialize({ observable, field }) {
        field.ariaLabel = headerText;

        super.initialize({
          observable,
          field,
          headerText,
        });
      }
    };
  }
}
